import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { List } from 'semantic-ui-react';

import { UniversalLink } from '@plone/volto/components';

import { getDropdownMenuNavitems, getItemsByPath } from 'volto-dropdownmenu';

const FooterMenu = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const items = useSelector((state) => state.dropdownMenuNavItems?.result);
  useEffect(() => {
    dispatch(getDropdownMenuNavitems());
  }, [dispatch, location.pathname]);

  const menu = getItemsByPath(items, location.pathname);

  return menu?.length > 0 ? (
    <div className="iv--footer-menu">
      <List inverted>
        {menu
          ?.filter(
            (item) =>
              item.visible &&
              (item.mode === 'simpleLink' || item.showMoreLink?.length > 0),
          )
          ?.map((item, index) => {
            let linkItem = null;
            if (item.mode === 'simpleLink') {
              linkItem = item.linkUrl[0]?.['@id'] ? item.linkUrl[0] : null;
            } else {
              linkItem = item.showMoreLink[0];
            }
            return (
              linkItem && (
                <div role="listitem" className="item" key={index}>
                  <UniversalLink
                    href={item.linkUrl === '' ? '/' : null}
                    item={linkItem}
                  >
                    {item.title}
                  </UniversalLink>
                </div>
              )
            );
          })}
      </List>
    </div>
  ) : null;
};

export default FooterMenu;
